export default (opts = {}) => {
    const component = {
        model: {
            defaults: {
              type: 'div',
              attributes: { class: 'section bg-cinza' },
              components: [
                {
                  type: 'containerNumbers10',
                },
      
              ],
              styles: `
             .section{
               position:relative; 
               with:100vw; 
               padding: 75px 5%; 
             }
             .bg-cinza{
                background: #F6F6F6;
             }
             *{
              font-family: Roboto, Arial, sans-serif;
            }
            `,
            },
          },
          view: {
      
          },
};
  return component; 
};